import React from 'react';

import Typography from '../../library/typography/typography';
import {
  CircleExclamationSolidIcon,
  CircleXmarkSolidIcon
} from '../../shared/icons/icons';

import { ProductData } from '../../shared/types/graphql-types';
import { ARTICLE_STATUSES } from '../../shared/constants/products';

import './product-article-status-banner.one-dt.scss';

interface ProductArticleStatusBannerProps {
  product: ProductData;
}

function ProductArticleStatusBanner(props: ProductArticleStatusBannerProps) {
  const {
    product: { articleStatus, articleStatusLabel, productLaunchDate } = {}
  } = props;
  return (
    <div
      className="product-article-status-banner__container"
      styleName="container"
    >
      {(articleStatus === ARTICLE_STATUSES.DISCONTINUED ||
        articleStatus === ARTICLE_STATUSES.BACKORDER ||
        articleStatus === ARTICLE_STATUSES.QUALITY_HOLD ||
        articleStatus === ARTICLE_STATUSES.TEMPORARILY_UNAVAILABLE) && (
        <CircleXmarkSolidIcon
          className="product-article-status-banner__icon-discontinued"
          styleName="icon-discontinued"
        />
      )}
      {articleStatus === ARTICLE_STATUSES.PRE_LAUNCH && (
        <CircleExclamationSolidIcon
          className="product-article-status-banner__icon-prelaunch"
          styleName="icon-prelaunch"
        />
      )}
      <Typography
        className="product-article-status-banner__label"
        tag="div"
      >{`${articleStatusLabel}${
        productLaunchDate && articleStatus === ARTICLE_STATUSES.PRE_LAUNCH
          ? `: ${productLaunchDate}`
          : ''
      }`}</Typography>
    </div>
  );
}

export default ProductArticleStatusBanner;
